<script>
  export let dragAndDrop
  export let error
  export let settings
  export let type = 'review'

  let accept
  let showOnDevice
  $: if (settings) {
    let acceptString
    showOnDevice =
      settings.widget_settings[`${type}_form`].collect_photo_reviews ||
      settings.widget_settings[`${type}_form`].collect_video_reviews

    acceptString = settings.widget_settings[`${type}_form`]
      .collect_photo_reviews
      ? 'image/*,'
      : ''

    acceptString += settings.widget_settings[`${type}_form`]
      .collect_video_reviews
      ? 'video/*'
      : ''
    accept = acceptString
  }
</script>

<style>
  :global(._1n3mf) {
    margin-bottom: 8px;
  }

  .drop-zone {
    display: flex;
    align-items: center;
  }

  :global(._2yyX8) {
    width: 98px;
    height: 98px;
    background: #f6f6f9;
    text-align: center;
    color: rgb(105, 108, 133);
    border: 1.3px dashed rgb(223, 229, 235);
    display: flex;
    transition: transform 0.3s ease 0s;
    -webkit-box-align: center;
    align-items: center;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 14px;
    position: relative;
  }

  :global(._2yyX8) p {
    line-height: 16px;
  }

  input[type='file'] {
    position: absolute;
    height: 77px;
    width: 100%;
    opacity: 0;
    left: 0;
  }

  input[type='file']:focus {
    background: #e6e6eb;
    opacity: 0;
  }

  :global(._1ALiJ) {
    width: 100%;
    margin: -3px 0 5px 1px;
    color: #dc3545;
  }
</style>

{#if showOnDevice}
  <div class="_1n3mf  drop-zone" id="dropArea">
    <slot />
    <div class="_2yyX8">
      <input
        type="file"
        on:change={e => dragAndDrop(e)}
        on:drop={() => {}}
        multiple
        {accept} />
      <p>{settings.translations.review_form.drag_and_drop_media_text}</p>
    </div>
  </div>
  {#if error !== false}
    <div class="_1ALiJ">{error}</div>
  {/if}
{/if}
